import { ContractSchema } from '~api/carrier_contracts';

import { CardHintText, Tooltip } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractsListSchemasQuery } from '../schema/queries';

interface Props {
  schemaId: string | undefined;
}

interface ContentProps {
  schema: ContractSchema;
}

function Content({ schema: { carrier_name, carrier_products = [] } }: ContentProps) {
  const { t } = useTranslation();

  const childs: (string | JSX.Element)[] = [
    t('carrierContracts.create.carrierIncludesIncludes', { carrier: carrier_name }),
    ' ',
  ];

  /**
   * If there's 5 products or less, we should show them inline
   * otherwise in a tooltip, to reduce UI bloating.
   */
  if (carrier_products.length <= 5) {
    childs.push(carrier_products.map(({ product_name }) => product_name).join(', '));
  } else {
    childs.push(
      <Tooltip
        content={carrier_products.map(({ product_name }, index) => (
          <div key={`product-${index}`}>{product_name}</div>
        ))}
        key="carrier-product-tooltip"
      >
        <span style={{ textDecoration: 'underline' }}>
          {t('carrierContracts.create.countCarrierProducts', {
            count: carrier_products.length,
            carrier: carrier_name,
          })}
        </span>
      </Tooltip>
    );
  }

  return childs;
}

export function CarrierProducts({ schemaId }: Props) {
  const { data: schemas } = useCarrierContractsListSchemasQuery();

  if (!schemaId) {
    return null;
  }

  const schema = schemas.find(schema => schema.schema_id === schemaId)!;

  return (
    <CardHintText>
      <Content schema={schema} />
    </CardHintText>
  );
}
